import PropTypes from 'prop-types';
import { Field } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormHelperText from '@material-ui/core/FormHelperText';
import ReactDatetime from 'react-datetime';
import { momentParse } from '../../utils/time';

const useStyles = makeStyles(theme => ({
  field: {
    margin: theme.spacing(1, 0),
  }
}));

const TimeField = (props) => {
  const {
    name,
    label,
    labelWidth,
    className,
    disabled,
    touched,
    helperText,
  } = props;
  const classes = useStyles();

  return (
    <Field name={name}>
      {({ field, form }) => {
        const parsedValue = momentParse(field.value);
        const onChange = (date) => {
          form.setFieldValue(field.name, date);
          form.setFieldTouched(field.name, true);
        };
        const currentError = form.errors[field.name];
        return (
          <ReactDatetime
            dateFormat={false}
            timeFormat="h:mm A"
            value={parsedValue}
            onChange={onChange}
            renderInput={(dateInputProps) => (
              <FormControl
                variant="outlined"
                className={clsx(classes.field, className)}
                error={touched && Boolean(currentError)}
              >
                <InputLabel htmlFor={name}>
                  {label}
                </InputLabel>
                <OutlinedInput
                  id={name}
                  type="text"
                  labelWidth={labelWidth}
                  disabled={disabled}
                  {...dateInputProps}
                />
                {((touched && currentError) || helperText) && (
                  <FormHelperText>
                    {(touched && currentError) || helperText}
                  </FormHelperText>
                )}
              </FormControl>
            )}
          />
        );
      }}
    </Field>
  );
};

TimeField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  labelWidth: PropTypes.number,
  className: PropTypes.string,
  helperText: PropTypes.node,
};

export default TimeField;
